// import BusAPI from "./busAPITest";
import BusAPI from "./busAPI";

import "@babel/polyfill";

import { AppendSearchOption } from "./tools";

class BusService {
  constructor() {
    this.data = {};
  }

  static async platformResults(selectedPlatform) {
    try {
      const platformData = await BusAPI.getPlatformTag(selectedPlatform);
      return platformData;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  static async platformsByStreet(street) {
    try {
      const platformData = await BusAPI.getPlatformsForStreet(street);
      return platformData.data;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  static submitRTISearchWithPlatformTag(PlatformTag) {
    let completeUrl = "/api/nextbus";
    completeUrl = AppendSearchOption(
      completeUrl,
      "PlatformTag",
      encodeURIComponent(PlatformTag)
    );

    return BusAPI.callData(completeUrl);
  }
}

export default BusService;
